<template>
  <v-container fluid class="no-padding-top">
    <v-row no-gutters>
      <v-col cols="12" class="limited-scrollable">
        <NewOrdersList
          v-if="$store.state.status[1]"
          :dataLoaded.sync="dataLoaded"
          :orders="$store.state.orders[$store.state.status[1]]" />
        <PreparingOrdersList
          v-if="$store.state.status[2]"
          :dataLoaded.sync="dataLoaded"
          :orders="$store.state.orders[$store.state.status[2]]" />
        <ReadyOrdersList
          v-if="$store.state.status[3]"
          :dataLoaded.sync="dataLoaded"
          :orders="$store.state.orders[$store.state.status[3]]" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import NewOrdersList from '../components/NewOrdersList';
  import PreparingOrdersList from '../components/PreparingOrdersList';
  import ReadyOrdersList from '../components/ReadyOrdersList';

  export default {
    name: 'Index',
    components: {
      NewOrdersList,
      PreparingOrdersList,
      ReadyOrdersList
    },
    beforeMount() {
      if (this.$store.getters.noOrders) {
        this.getDataCall()
          .then((result) => {
            if (result.code == 200) {
              this.$store
                .dispatch('handleOrders', {
                  orders: result.result
                })
                .then(() => {
                  this.handleInconsistencies();
                })
                .catch(() => {
                  this.dataLoaded = true;
                });

            } else {
              this.dataLoaded = true;
            }
          })
          .catch(() => {
            this.dataLoaded = true;
          });
      } else {
        this.dataLoaded = true;
        this.handleInconsistencies();
      }
    },
    mounted() {},
    data: () => ({
      dataLoaded: false,
    }),
    methods: {
      handleInconsistencies() {
        if (Object.keys(this.$store.state.orders.inconsistents).length > 0) {
            this.inconsistentsCall()
              .then((result) => {
                if (result.code == 200) {
                  this.$store
                    .dispatch('handleInconsistencies', {
                      inconsistenciesResponse: result.result
                    })
                    .then(() => {
                      this.dataLoaded = true;
                    });
                } else {
                  this.dataLoaded = true;
                }
              })
              .catch(() => {
                this.dataLoaded = true;
              });
          } else {
            this.dataLoaded = true;
          }
      },
      async getDataCall() {
        const session = this.$store.state.session;
        const params = {
          storePickUpCode: session.storePickUpCode,
          defaultShipping: session.defaultShipping
        };

        return await this.$magentoAxios.get('orders', params);
      },
      async inconsistentsCall() {
        const session = this.$store.state.session;

        return await this.$magentoAxios.post('resolveInconsistencies', {
          storeId: session.storeId,
          sucursal: session.storePickUpCode,
          Inconsistencias: this.$store.state.orders.inconsistents
        });
      },
    },
  }
</script>

<style scoped></style>